import { useEffect, useState } from 'react';
import { useI18n } from '../i18n';
import './PresenceChip.css';

const API = import.meta.env.VITE_API_URL || 'http://localhost:8000';

interface Presence {
  online: number;
  active_games: number;
}

export function PresenceChip() {
  const { t } = useI18n();
  const [data, setData] = useState<Presence | null>(null);

  useEffect(() => {
    let mounted = true;
    const load = () => {
      fetch(`${API}/presence`)
        .then(r => (r.ok ? r.json() : null))
        .then(d => { if (mounted && d) setData(d); })
        .catch(() => {});
    };
    load();
    const t = setInterval(load, 10000);
    return () => { mounted = false; clearInterval(t); };
  }, []);

  if (!data) return null;
  return (
    <div className="presence-chip">
      <span className="presence-dot" />
      <span className="presence-count">{data.online}</span>
      <span className="presence-label">{t.common.online}</span>
      {data.active_games > 0 && (
        <>
          <span className="presence-sep">·</span>
          <span className="presence-games">⚔️ {data.active_games}</span>
        </>
      )}
    </div>
  );
}
